import { useLocalization } from "@fluent/react";
import { Chip } from "@narmi/design_system";
import Filters from "byzantine/src/filters";
import cc from "classcat";

import MerchantIcon from "../../../../components/subscriptions/MerchantIcon";

import columnStyles from "./ledgerColumns.module.scss";
import { AmountCell, transactionDescription } from "./ledgerColumns";
import styles from "./LedgerPanelHeader.module.scss";

const LedgerPanelHeader = ({
  transaction,
}: {
  transaction: API.Transaction;
}) => {
  const { l10n } = useLocalization();
  const description = transactionDescription(transaction);
  const merchantMatched = transaction.merchant_matched;
  const meta = [
    l10n.getString(
      transaction.type === "credit"
        ? "live-ledger-type-deposit"
        : "live-ledger-type-withdrawal"
    ),
    transaction.settled_at
      ? Filters.shortMonthDayYear(transaction.settled_at)
      : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <div
      className={cc([
        styles.headerCard,
        "border--all",
        "rounded--all--l",
        "padding--all--l",
      ])}
      data-testid="ledger-panel-header"
    >
      <div className={styles.amountRow}>
        <span className="fontSize--heading3">
          <AmountCell amount={transaction.amount} />
        </span>
        {!transaction.settled_at && (
          <Chip
            label={l10n.getString("live-ledger-status-pending")}
            kind="secondary"
          />
        )}
      </div>
      <div className={columnStyles.description}>
        <MerchantIcon
          name={description}
          iconName={merchantMatched ? undefined : "dollar-sign"}
          size="s"
          variant={merchantMatched ? "muted" : "branded"}
        />
        <span className={columnStyles.descriptionText}>{description}</span>
      </div>
      <div className="fontSize--s fontColor--secondary">{meta}</div>
    </div>
  );
};

export default LedgerPanelHeader;
